<div class="grid">
   <div class="col-12 mb-4" [class]="this.underTablet() ? 'flex justify-content-center' : ''">
      <form [formGroup]="siteFilters">
         <div class="grid mt-0">
            <div [class]="colFilterResponsive('button')">
               <p-button id="buttonAddSite" label="{{ 'NEW_SITE' | translate }}" icon="pi cm-plus"
                  (click)="onCreateSite()" [disabled]="isImpers" [rounded]="false" [text]="true" severity="primary"
                  styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
               </p-button>
            </div>
            <div [class]="colFilterResponsive('filter')">
               <div class="flex justify-content-between flex-wrap border-bottom-1 border-900"
                  [ngClass]="simpleInputTextLayout('borderRow')">
                  <div class="flex align-items-center justify-content-center"
                     [ngClass]="simpleInputTextLayout('label')">{{
                     'TYPE' | translate }}</div>
                  <div class="flex align-items-center justify-content-center"
                     [ngClass]="simpleInputTextLayout('borderInput')">
                     <p-dropdown [options]="siteType" formControlName="type" [ngClass]="dynamicInputTextWidth()"
                        styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5 surface-900">
                        <ng-template let-item pTemplate="selectedItem">
                           <div class="item flex align-items-center justify-content-center">
                              <div class="flex align-items-center"
                                 [class]="item.label === 'SITE_ALL' ? 'text-gray-500' : ''">{{ item.label | translate }}
                              </div>
                           </div>
                        </ng-template>
                        <ng-template let-section pTemplate="item">
                           <div class="item flex justify-content-center">
                              <div>{{section.label | translate }}</div>
                           </div>
                        </ng-template>
                     </p-dropdown>
                  </div>
               </div>
            </div>
            <!-- EMPTY CONTAINER FOR LAYOUT DESKTOP -->
            <div [class]="colFilterResponsive('empty')"></div>
            <!-- SEARCH TABLET && MOBILE -->
            <div [class]="colFilterResponsive('filter') + (screenWidth >= LG_WIDTH ? ' flex justify-content-end' : '')">
               <div *ngIf="tabletUnderLgWidth() || onExtendedMobile()"
                  class="flex justify-content-between flex-wrap border-bottom-1 border-900"
                  [ngClass]="simpleInputTextLayout('borderRow')">
                  <div class="flex align-items-center justify-content-center"
                     [ngClass]="simpleInputTextLayout('label')">{{
                     'SITE_NAME' | translate }}</div>
                  <div class="flex align-items-center justify-content-center"
                     [ngClass]="simpleInputTextLayout('borderInput')">
                     <span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
                        <i class="pi cm-search"></i>
                        <input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
                           class="pr-6 surface-900" id="supportrequest-rbelog-input-search"
                           placeholder="{{ 'SEARCH' | translate }}" maxlength="254" />
                     </span>
                  </div>
               </div>
               <!-- SEARCH DESKTOP -->
               <div *ngIf="!tabletUnderLgWidth() && !onExtendedMobile()"
                  class="flex align-items-center justify-content-center"
                  [ngClass]="simpleInputTextLayout('borderInput')">
                  <span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
                     <i class="pi cm-search"></i>
                     <input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
                        class="pr-6 surface-900" id="supportrequest-rbelog-input-search"
                        placeholder="{{ 'SEARCH' | translate }}" maxlength="254" />
                  </span>
               </div>
            </div>
         </div>
      </form>
   </div>
</div>